<template>
  <div class="bg-body-tertiary">
    <div id="liff" class="d-flex flex-column mx-auto">
      <div class="py-5 px-3 mx-auto bg-body-tertiary text-center" id="plan">
        <!-- header -->
        <div class="position-fixed top-0 start-50 translate-middle-x w-100 mw-640 z-5 bg-body-tertiary">
          <div class="h-42 w-100 d-flex align-items-center ps-4 pe-3 justify-content-end">
            <button @click="$router.back()" role="button" class="btn border-0 p-0 lh-1 opacity-75">
              <svg width="28" height="28"><use xlink:href="#close-lg"/></svg>
            </button>
          </div>
        </div>

        <h3>方案說明</h3>
        
        <!-- 重新訂閱提示 -->
        <!-- <div v-if="isResubscribe && currentSubscription" class="alert alert-info text-start mx-auto mb-4" style="max-width: 600px;">
          <h6>📋 重新訂閱說明</h6>
          <p class="mb-2">您目前的訂閱將於 <strong>{{currentSubscription.endDate}}</strong> 到期。</p>
          <p class="mb-0">新的訂閱將從到期日翌日開始，不會影響您當前的服務使用。</p>
        </div> -->
        
        <div class="my-4 my-md-5 mx-auto">
          <div class="flex-table rule mx-auto">
            <div>
              <div class="th"></div>
              <div class="th">基本型</div>
              <div class="th bg-primary-mix-white-80">進階型</div>
            </div>
            <div>
              <div class="td text-start">無限搜尋比價</div>
              <div class="td text-primary"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
              <div class="td text-primary bg-primary-mix-white-80"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
            </div>
            <div>
              <div class="td text-start">無限短網址轉換</div>
              <div class="td text-primary"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
              <div class="td text-primary bg-primary-mix-white-80"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
            </div>
            <div>
              <div class="td text-start">自動生成商品文</div>
              <div class="td text-primary"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
              <div class="td text-primary bg-primary-mix-white-80"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
            </div>
            <div>
              <div class="td text-start">訂單管理額度</div>
              <div class="td">50筆</div>
              <div class="td bg-primary-mix-white-80">無限制</div>
            </div>
            <div class="pro">
              <div class="td text-start pt-4.5 pb-2"><b>進階訂單功能</b><small class="text-muted">（陸續推出）</small></div>
              <div class="td pt-4.5 pb-2"></div>
              <div class="td text-primary bg-primary-mix-white-80 pt-4.5 pb-2"></div>
            </div>
            <div class="pro">
              <div class="td text-start"><ul class="custom-ul"><li>老顧客、團隊夥伴管理</li></ul></div>
              <div class="td"></div>
              <div class="td text-primary bg-primary-mix-white-80"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
            </div>
            <div class="pro">
              <div class="td text-start"><ul class="custom-ul"><li>購買記錄、聯絡方式分類</li></ul></div>
              <div class="td"></div>
              <div class="td text-primary bg-primary-mix-white-80"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
            </div>
            <div class="pro">
              <div class="td text-start"><ul class="custom-ul"><li>團隊聯絡、熟客回訪</li></ul></div>
              <div class="td"></div>
              <div class="td text-primary bg-primary-mix-white-80"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
            </div>
            <div class="pro">
              <div class="td text-start"><ul class="custom-ul"><li>收款提醒、下單提醒</li></ul></div>
              <div class="td"></div>
              <div class="td text-primary bg-primary-mix-white-80"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
            </div>
            <div class="pro">
              <div class="td text-start pb-4.5 border-bottom"><ul class="custom-ul"><li>數據統計分析圖表</li></ul></div>
              <div class="td pb-4.5 border-bottom"></div>
              <div class="td text-primary bg-primary-mix-white-80 pb-4.5 border-bottom border-black border-opacity-10"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
            </div>
          </div>
          <div class="small p-3 mb-4 light-mix-black-40">
            * 基本型永久免費使用<br>
            * 進階型付費方案結束後自動續訂<br>
            * 取消訂閱將使用至期間結束
          </div>
        </div>
        <h2 class="text-primary display-6"><b>馬上開始使用進階功能！</b></h2>

        <div class="container text-center my-4 my-md-5 p-0">
          <div class="row g-4">
            <div class="col-md-4">
              <div class="h-100 border border-2 border-dark-subtle rounded-4 p-3 p-md-4 mx-auto plan-outline">
                <h4 class="text-muted">基本型</h4>
                <div class="mt-3 mt-md-4">
                  <button class="plan btn btn-lg btn-outline-dark rounded-pill mb-2" disabled><b>終身免費</b></button>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div role="button" @click="openModal('3')" class="h-100 border border-2 border-primary rounded-4 p-3 p-md-4 mx-auto plan-outline box-shadow">
                <h4>進階型</h4>
                <div class="mt-3 mt-md-4">
                  <button @click="openModal('3')" class="plan btn btn-lg btn-primary text-white rounded-pill mb-2"><b>季付方案</b></button>
                  <p class="m-0">NT$ 299 / 季</p>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div role="button" @click="openModal('4')" class="h-100 border border-4 border-primary rounded-4 p-3 p-md-4 mx-auto plan-outline box-shadow">
                <h4>進階型</h4>
                <div class="mt-3 mt-md-4">
                <button @click="openModal('4')" class="plan btn btn-lg btn-primary text-white rounded-pill mb-2"><b>年付方案</b></button>
                  <p class="m-0">NT$ 999 / 年<br><b class="text-danger">超值優惠</b></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 開發環境測試方案 -->
        <div class="m-2 m-md-4" v-if="isDevelopment">
          <button @click="openModal('999')" class="plan btn btn-lg btn-warning text-white rounded-pill mb-2"><b>測試方案</b></button>
          <p>NT$ 10 / 日<br><small class="text-muted">僅開發測試</small></p>
        </div>
      </div>

    </div>
  </div>

  <div ref="planModal" class="modal fade" id="planModal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-fullscreen-sm-down modal-dialog-scrollable">
      <div class="modal-content needs-validation" novalidate>
        <div class="modal-header">
          <div class="plan w-100 text-center"><b>方案：</b>{{planTitle}} <b class="text-info">${{planPrice}}</b></div>
        </div>
        <div class="modal-body p-0" v-if="!isAgree">
          <terms></terms>
        </div>
        <div class="modal-body" v-else-if="isAgree">
          <div class="d-flex justify-space-between text-nowrap mb-3">
            <b class="w-100">付費方式</b> <div class="ecLogo bgCenterCover"></div>
            <!-- <img class="icon" src="@/assets/img/LINE-Pay.png" /> -->
          </div>
          <h6>開立電子發票資訊</h6>

          <div class="form-floating mb-2" :class="{ 'invalid': submitted && !name }">
            <input v-model="name" type="text" class="form-control" id="userName" placeholder="姓名" required>
            <label for="userName">姓名 <b class="text-danger">*</b></label>
          </div>
          <div class="small text-end mb-2">
            <span class="text-danger" v-show="submitted && !name">這是必填欄位</span>
          </div>

          <div class="form-floating mb-2" :class="{ 'invalid': (submitted && !my_email) || (my_email && !isValidEmail) }">
            <input v-model="my_email"  type="email" class="form-control" id="userEmail" placeholder="Email" required>
            <label for="userEmail">Email <b class="text-danger">*</b></label>
          </div>
          <div class="small text-end mb-2">
            <span class="text-danger" v-show="submitted && !my_email">這是必填欄位<br></span>
            <span class="text-danger" v-show="my_email && !isValidEmail">請輸入正確的email格式<br></span>
            <span class="text-muted">請輸入可接收電子發票通知的Email</span>
          </div>

          <div class="form-floating mb-2" :class="{ 'invalid': this.carrier && !isValidCarrier }">
            <input v-model="carrier" type="text" class="form-control" id="userCarrier" placeholder="手機條碼載具">
            <label for="userCarrier">手機條碼載具</label>
          </div>
          <div class="small text-end mb-2" v-show="this.carrier && !isValidCarrier">
            <span class="text-danger">請輸入正確的格式</span>
          </div>

          <div class="form-floating mb-2" :class="{ 'invalid': this.tax_id && !isValidTaxId }">
            <input v-model="tax_id" type="text" inputmode="numeric" class="form-control" id="userTaxId" placeholder="統一編號">
            <label for="userTaxId">統一編號</label>
          </div>
          <div class="small text-end mb-2" v-show="this.tax_id && !isValidTaxId">
            <span class="text-danger">請輸入正確的格式</span>
          </div>

        </div>
        <div v-if="!isAgree" class="modal-footer">
          <button class="btn btn-primary text-white w-100 h-48" @click="isAgree = true"><b>同意並繼續</b></button>
          <button class="btn btn-light w-100 h-48" data-bs-dismiss="modal" aria-label="Close" @click="closeModal(),isAgree = false">取消</button>
        </div>
        <div v-else-if="isAgree" class="modal-footer">
          <button class="btn btn-primary text-white w-100 h-48" @click="navigateToPayUrl"><b>確認訂閱</b></button>
          <button class="btn btn-light w-100 h-48" data-bs-dismiss="modal" aria-label="Close" @click="closeModal()">取消</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import terms from '@/components/termsPrivacy.vue';
import axios from 'axios';
import liff from '@line/liff';
import { mapActions, mapGetters } from 'vuex';
import { Modal } from 'bootstrap';
import { SubscriptionStatus } from '@/utils/setup.js';

let liff_callback = process.env.VUE_APP_LIFF_CALLBACK;
let api_url = process.env.VUE_APP_API_URL;
let greenworld_api_url = process.env.VUE_APP_GREENWORLD_API_URL;

export default {
  name: 'PlanView',
  components: {
    terms
  },
  data () {
    return {

      modal: null,
      planTitle: null,
      planPrice: null,
      planId: null,
      pay_url: null,
      isAgree: false,
      refreshTokenInterval: null,
      tax_id: null,
      carrier: null,
      name: null,
      my_email: '',
      submitted: false,
      isResubscribe: false, // 是否為重新訂閱
      currentSubscription: null // 當前訂閱資訊
    }
  },
  async mounted() {

    if (this.userId) {

      this.my_email = this.email;

      // 檢查 URL 參數是否為重新訂閱
      const urlParams = new URLSearchParams(window.location.search);
      this.isResubscribe = urlParams.get('resubscribe') === 'true';
      
      // 檢查訂閱狀態
      let status = await this.getSubscriptionStatus();
      
      // 如果是 Active 狀態，需要進一步檢查是否可以重新訂閱
      if (status['main'] == SubscriptionStatus.ACTIVE) {
        if (!this.isResubscribe) {
          // 如果不是重新訂閱，且狀態為 Active，重導向到會員資訊
          this.$router.push('/main?tab=會員資訊');
          return;
        } else {
          // 如果是重新訂閱，獲取當前訂閱資訊
          await this.getCurrentSubscriptionInfo();
        }
      }

      // 初始化 Modal（只初始化一次）
      const planModalElement = document.getElementById('planModal');
      if (planModalElement) {
        this.modal = new Modal(planModalElement);
        
        // 監聽 modal 關閉事件
        planModalElement.addEventListener('hidden.bs.modal', this.handleModalHidden);
      }

      // 每 3 分鐘更新 token
      this.refreshTokenInterval = setInterval(async () => {
        await this.refreshToken();
      }, 3 * 60 * 1000);

    }
    else {
      this.$router.push('/me?page=plan');
      return;
    }
    
  },

  beforeUnmount() {
    // 清理 interval
    if (this.refreshTokenInterval) {
      clearInterval(this.refreshTokenInterval);
    }

    // 清理事件監聽
    const planModalElement = document.getElementById('planModal');
    if (planModalElement) {
      planModalElement.removeEventListener('hidden.bs.modal', this.handleModalHidden);
    }

    // 銷毀 Modal 實例
    if (this.modal) {
      this.modal.dispose();
      this.modal = null;
    }

    // 清理可能殘留的 backdrop
    this.cleanupBackdrops();
  },
  computed: {
    ...mapGetters(['token', 'refresh_token', 'userId', 'email']),

    isValidEmail() {
      // 檢查 my_email 是否符合 email 格式
      let emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (this.my_email && emailReg.test(this.my_email)) {
        return true;
      }
      else {
        return false;
      }
    },

    isValidCarrier() {
      // 檢查 carrier 是否符合手機條碼載具格式
      let carrierReg = /^\/[0-9a-zA-Z+-.]{7}$/;
      if (this.carrier && carrierReg.test(this.carrier)) {
        return true;
      }
      else {
        return false;
      }
    },

    isValidTaxId() {
      // 檢查 tax_id 是否符合統一編號格式
      let taxIdReg = /^[0-9]{8}$/;
      if (this.tax_id && taxIdReg.test(this.tax_id)) {
        return true;
      }
      else {
        return false;
      }
    },

    isDevelopment() {
      // 判斷是否為開發環境
      return process.env.NODE_ENV === 'development';
    },
  },
  methods: {

    ...mapActions(['setToken', 'clearToken', 'setUserId', 'clearUserId']),

    // 處理 modal 關閉事件
    handleModalHidden() {
      this.isAgree = false;
      this.submitted = false;
    },

    // 清理所有 backdrop
    cleanupBackdrops() {
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => backdrop.remove());
      
      document.documentElement.classList.remove('modal-open');
      document.documentElement.style.removeProperty('overflow');
      document.documentElement.style.removeProperty('padding-right');
      
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
    },

    // 獲取當前訂閱資訊
    async getCurrentSubscriptionInfo() {
      try {
        const response = await axios.get(`${api_url}/v1/users/${this.userId}/subscription`, {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            "ngrok-skip-browser-warning": "69420"
          }
        });

        if (response.data && response.data.subscription) {
          this.currentSubscription = {
            endDate: response.data.subscription.EndDate,
            status: response.data.subscription.Status,
            autoRenew: response.data.subscription.AutoRenew
          };
        }
      } catch (error) {
        console.error('Error fetching current subscription:', error);
      }
    },

    navigateToPayUrl() {

      this.submitted = true;

      if (!this.name || !this.my_email || !this.isValidEmail || (this.carrier && !this.isValidCarrier) || (this.tax_id && !this.isValidTaxId)) {
        return;
      }

      this.get_payment_url_greenworld().then((res) => {
        console.log(res);

        if (res) {
          let form = document.createElement('form');
          form.method = 'POST';
          form.action = greenworld_api_url;

          for (let key in res) {
            let input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = res[key];
            form.appendChild(input);
          }

          document.body.appendChild(form);
          form.submit();
        }
        else {
          console.log('不需要授權');
          this.$router.push('/main');
          return;
        }
        
      });

    },

    async get_payment_url_greenworld() {
      try {
        const baseURL = `${api_url}/v1/users/redirect_to_pay_uri`;

        const response = await axios.post(baseURL, {
          user_id: this.userId,
          subscription_id: this.planId,
          email: this.my_email,
          name: this.name,
          carrier: this.carrier,
          tax_id: this.tax_id
        });

        return response.data;
      } catch (error) {
        console.error('Error sending POST request:', error);
        return false;
      }
    },

    async get_payment_url() {
      try {
        const baseURL = `${api_url}/get_payment`;

        const response = await axios.post(baseURL, {
          user_id: this.userId,
          subscription_id: this.planId,
          email: this.my_email,
          name: this.name,
          carrier: this.carrier,
          tax_id: this.tax_id
        });

        if (response.data && response.data.returnCode == "0000") {
          if (liff.getOS() === "ios" || liff.getOS() === "android") {
            return response.data.info.paymentUrl.web;
          } else {
            return response.data.info.paymentUrl.web;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.error('Error sending POST request:', error);
        return false;
      }
    },

    async refreshToken() {

      try {
        const baseURL = `${api_url}/v1/user/refresh/${this.userId}`;

        const response = await axios.get(baseURL, {
          headers: {
            'Authorization': `Bearer ${this.refresh_token}`,
            "ngrok-skip-browser-warning": "69420"
          }
        });

        if (response.data.result == "OK") {
          this.setToken(response.data.token);
          return true;
        } else {
          console.log('refreshToken not OK');
          liff.logout();
          setTimeout(() => {
            liff.login({ redirectUri: `${liff_callback}?page=${this.$route.query.page}` }); 
          }, 500);
          return false;
        }
      } catch (error) {
        console.error('Error refresh token:', error);
        liff.logout();
        setTimeout(() => {
          liff.login({ redirectUri: `${liff_callback}?page=${this.$route.query.page}` }); 
        }, 500);
        return false;
      }
    },

    async getSubscriptionStatus() {

/*       return {
        main: SubscriptionStatus.ACTIVE,
        sub: ''
      } */
      //TODO: 這裡要改成呼叫 API
      try {
        const baseURL = `${api_url}/v1/users/${this.userId}/subscription_status`;

        const response = await axios.get(baseURL, {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            "ngrok-skip-browser-warning": "69420"
          }
        });

        console.log(response.data);

        return response.data

      } catch (error) {
        console.error('Error sending GET request:', error);
        return false;
      }
    },

    // modal
    openModal(type) {
      // 使用已初始化的 modal 實例
      if (this.modal) {
        this.planId = type;
        if (type == '1') {
          this.planTitle = "基本型 / 季付"
          this.planPrice = "0"
        } else if (type == '2') {
          this.planTitle = "基本型 / 年付"
          this.planPrice = "0"
        } else if (type == '3') {
          this.planTitle = "進階型 / 季付"
          this.planPrice = "299"
        } else if (type == '4') {
          this.planTitle = "進階型 / 年付"
          this.planPrice = "999"
        } else if (type == '999') {
          this.planTitle = "測試方案 / 日付"
          this.planPrice = "10"
        }
        
        this.modal.show();
      }
    },
    closeModal() {
      if (this.modal) {
        this.modal.hide();
      }
      this.isAgree = false;
      this.pay_url = null;
      this.submitted = false;
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  #liff {
    width: 100%;
    max-width: 640px;
    min-height: 100vh;
    > * {
      width: 100%;
    }
  }

  .mw-600 {max-width: 600px;}
  .h-48 {height: 48px;}
  .fs-xs {
    font-size: .625rem;
    line-height: 1rem;
  }
  
  .flex-table {
    display: table;
    width: 100%;
    > * {display: table-row;}
    .th,.td {
      display: table-cell;
      text-align: center;
      vertical-align: middle;
    }
    &.rule {
      max-width: 600px;
      .th,.td {
        padding: 1.5rem 4px;
        font-size: 1.2rem;
        line-height: 1.75;
        .icon-check {
          width: 36px;
          height: 36px;
        }
        @media only screen and (max-width: 576px) {
          padding: 1rem 4px;
          font-size: 1rem;
          line-height: 1.5;
          .icon-check {
            width: 28px;
            height: 28px;
          }
        }
      }
      .th {
        border-bottom: 1px solid rgba($color: #000, $alpha: .1);
        font-weight: bolder;
      }
      .td {
        border-bottom: 1px solid rgba($color: #000, $alpha: .1);
      }
      .pro {
        >.td {
          padding:.75rem 4px;
          border: none;
          @media only screen and (max-width: 576px) {
            padding:.5rem 4px;
          }
        }
      }
    }
    .note {
      margin-left : .5rem;
      text-indent : -.5rem;
    }
  }
  .plan {
    min-width:140px;
    font-size: 1.2rem;
    @media only screen and (max-width: 576px) {font-size: 1rem;}
  }
  .icon {
    width: auto;
    height: 21px;
  }
  .ecLogo {
    width: 8rem;
    height: 2rem;
    background-image: url(@/assets/img/ecpay.png);
  }
  .plan-outline {
    max-width:300px;
    &.box-shadow:hover {
      box-shadow: 2px 6px 12px rgba(0, 0, 0, 0.2);
      transition: box-shadow 0.2s ease-in-out;
    }
  }

</style>

